import Plot from "react-plotly.js";
import { IChart } from "service/forbush/interface";

type Props = {
  data: IChart[];
};

const Chart = ({ data }: Props) => {
  const nticks = window.innerWidth > 992 ? 24 : 0;
  console.log("data", data);

  return (
    <iframe src="https://neutronm.bartol.udel.edu/~pyle/json/bartol_ql_10min.html" width="800px" height="480px" style={{ maxWidth: "100%" }} title="bartol" />
    // <Plot
    //   data={data as Plotly.Data[]}
    //   useResizeHandler
    //   style={{ width: "100%", height: "100%" }}
    //   layout={{
    //     margin: { t: 10, b: 0, l: 50, r: 0 },
    //     autosize: true,
    //     // colorway: ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52"],
    //     colorway: ["#919324", "#01A8B9", "#FF336A", "#45A323", "#005A98", "#FE3024", "#00996E", "#501375", "#006B15", "#132E9B"],
    //     font: { color: "#999", size: 12 },
    //     paper_bgcolor: "#000000",
    //     plot_bgcolor: "#000000",
    //     xaxis: { gridcolor: "#222", tickangle: 30, gridwidth: 0.5, linecolor: "black", linewidth: 1, nticks: nticks, tickfont: { size: 12 }, showgrid: true, showline: true, title: { font: { size: 18 }, text: "Time (UT)" }, automargin: true },
    //     // yaxis: { gridcolor: "#222", gridwidth: 0.5, linecolor: "black", linewidth: 1, range: [1.7781512503836436, 2.03342375548695], tickfont: { size: 12 }, showgrid: true, showline: true, title: { font: { size: 13 }, standoff: 5, text: "10-min average count rates (Arbitrary log scale)" }, type: "log" },
    //     yaxis: { gridcolor: "#222", gridwidth: 0.5, linecolor: "black", linewidth: 1, tickfont: { size: 12 }, showgrid: true, showline: true, title: { font: { size: 13 }, standoff: 5, text: "10-min average count rates (Arbitrary log scale)" }, type: "log" },
    //   }}
    // />
  );
};

export default Chart;
